import { AbstractControl, ValidatorFn } from '@angular/forms';

export const urlValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: boolean } | null => {
  if (control.value !== '' && control.value !== null) {
    let url = control.value;
    let urlRegex = new RegExp(
      '^((ft|htt)ps?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    );
    if (!urlRegex.test(url)) return { URLinvalid: true };
    return null;
  } else return null;
};
